export default __webpack_public_path__ + "87d2e123eb52bf5c6b36818e4789ee49.svg";